"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockableEthersContractWrapperBuilder = exports.DEFAULT_PRICE = void 0;
var MockPriceFeed_1 = require("../../connector/impl/MockPriceFeed");
var EthersContractWrapper_1 = require("../EthersContractWrapper");
var EthersContractWrapperLite_1 = require("../EthersContractWrapperLite");
var DEFAULT_PRICE = function (forTime) { return ({
    prices: [
        { symbol: "ETH", value: 10 },
        { symbol: "AVAX", value: 5 }
    ],
    timestamp: forTime - 3000
}); };
exports.DEFAULT_PRICE = DEFAULT_PRICE;
var MockableEthersContractWrapperBuilder = /** @class */ (function () {
    function MockableEthersContractWrapperBuilder(baseContract, wrapperType) {
        this.baseContract = baseContract;
        this.wrapperType = wrapperType;
    }
    MockableEthersContractWrapperBuilder.prototype.using = function (mockPricePackage) {
        var mockConnector = new MockPriceFeed_1.MockPriceFeed(mockPricePackage);
        var wrapper = this.wrapperType === "full"
            ? new EthersContractWrapper_1.EthersContractWrapper(this.baseContract, mockConnector)
            : new EthersContractWrapperLite_1.EthersContractWrapperLite(this.baseContract, mockConnector);
        var result = wrapper.finish();
        // exposing "mockPrice" method on input Contract
        result["mockPrice"] = mockConnector.mock;
        return result;
    };
    return MockableEthersContractWrapperBuilder;
}());
exports.MockableEthersContractWrapperBuilder = MockableEthersContractWrapperBuilder;
//# sourceMappingURL=MockableEthersContractWrapperBuilder.js.map